<template>
  <div>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{$t("general")}}</v-tab>
      <v-tab key="Job Status">{{$t("entities.environment.tabs.form.jobStatus")}}</v-tab>
      <v-tab key="Job Stage Status">{{$t("entities.environment.tabs.form.jobStageStatus")}}</v-tab>
      <v-tab key="Calendar Prod">{{$t("entities.environment.tabs.form.calendarProd")}}</v-tab>
      <v-tab key="Calendar Exc">{{$t("entities.environment.tabs.form.calendarExc")}}</v-tab>
      <v-tabs-slider></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-container>
            <v-form ref="form" v-model="valid">
              <v-text-field
                v-model="value.description"
                :rules="$isRequiredRule"
                :label="$t('entities.environment.props.description')"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-tab-item>
        <v-tab-item key="Job Status">
          <jobStatusTabItem v-model="value" />
        </v-tab-item>
        <v-tab-item key="Job Stage Status">
          <jobStageStatusTabItem v-model="value" />
        </v-tab-item>
        <v-tab-item key="Calendar Prod">
          <calendarProdTabItem v-model="value" />
        </v-tab-item>
        <v-tab-item key="Calendar Exc">
          <calendarExcTabItem v-model="value" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>


<script>
import jobStatusTabItem from "../environments/jobStatusTabItem";
import jobStageStatusTabItem from "../environments/jobStageStatusTabItem";
import calendarProdTabItem from "../environments/calendarProdTabItem";
import calendarExcTabItem from "../environments/calendarExcTabItem";
export default {
  props: {
    value: {
      default: () => {
        return {
          description: "",
          jobStatus: [],
          jobStageStatus: [],
          calendarProds: [],
          calendarExcs: []
        };
      }
    }
  },
  components: {
    jobStatusTabItem,
    jobStageStatusTabItem,
    calendarProdTabItem,
    calendarExcTabItem
  },
  data() {
    return {
      tab: null,
      valid: true
    };
  },
  computed: {},
  methods: {
    isValid() {
      return this.$refs.form.validate();
    }
  },
  mounted() {}
};
</script>

